module.exports = __webpack_public_path__ + "static/TiemposText-Regular-72704e8ec4f22bb148b92b5663804233.ttf";